import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function SEO({ title, description, path = '/' }) {
    const fullTitle = title
        ? `${title} — CFL Ad Group`
        : 'CFL Ad Group — Direct Response Advertising for Automotive Dealerships';
    const desc = description ||
        'Direct response advertising agency specializing in traditional television (infomercials & TV spots), CTV/OTT, Social Media and Marketing Videos. 30+ years on air.';
    const url = `https://cfladgroup.com${path}`;
    return (
        <Helmet prioritizeSeoTags>
            <title>{fullTitle}</title>
            <meta name="description" content={desc} />
            <link rel="canonical" href={url} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={desc} />
            <meta property="og:url" content={url} />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={desc} />
        </Helmet>
    );
}
